module.exports = vendor_83f715a0;